import { forwardRef, type Ref, type SVGProps } from "react";
const IconSortDescendingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M20.586 29.414a2 2 0 0 0 2.828 0l6-6a2 2 0 1 0-2.828-2.828L24 23.172V4a2 2 0 1 0-4 0v19.172l-2.586-2.586a2 2 0 1 0-2.828 2.828zM2 22a2 2 0 0 0 2 2h2a2 2 0 1 0 0-4H4a2 2 0 0 0-2 2m0-6a2 2 0 0 0 2 2h6a2 2 0 1 0 0-4H4a2 2 0 0 0-2 2"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M2 10a2 2 0 0 0 2 2h12a2 2 0 1 0 0-4H4a2 2 0 0 0-2 2"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSortDescendingFilledSVG);
ForwardRef.displayName = "IconSortDescendingFilled";
export { ForwardRef as IconSortDescendingFilled };
